import React from 'react';
import {Link, Stack} from '@mui/material';
import {Body} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import type {ShipmentData} from '../shell/prepTypes';
import {carrierName, UNKNOWN_CARRIER} from './prepStatus';
import {brandLinkSx} from './prepStyles';
import styles from './PrepPage.module.scss';

interface TrackingInfoProps {
  shipment: ShipmentData;
  brandName: string;
}

function TrackingInfo({shipment, brandName}: TrackingInfoProps) {
  if (shipment.carrier === UNKNOWN_CARRIER) {
    return (
      <Stack
        component="section"
        spacing={0.75}
        className={styles.tracking}
        data-testid="prep-tracking"
      >
        <Body size="sm" className={styles.trackingLabel}>
          {translate('Tracking Information from {brand}:', {brand: brandName})}
        </Body>
        <Body size="md" data-testid="prep-tracking-code">
          {shipment.trackingCode}
        </Body>
      </Stack>
    );
  }

  return (
    <Stack
      component="section"
      spacing={0.75}
      className={styles.tracking}
      data-testid="prep-tracking"
    >
      <Body size="md">
        <strong>{translate('Carrier:')}</strong> {carrierName(shipment.carrier)}
      </Body>
      <Body size="md">
        <strong>{translate('Tracking #:')}</strong>{' '}
        {shipment.trackingCodeUrl ? (
          <Link
            href={shipment.trackingCodeUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={brandLinkSx()}
            data-testid="prep-tracking-link"
          >
            {shipment.trackingCode}
          </Link>
        ) : (
          <span data-testid="prep-tracking-code">{shipment.trackingCode}</span>
        )}
      </Body>
    </Stack>
  );
}

export default TrackingInfo;
